// extracted by mini-css-extract-plugin
export var background = "br_y";
export var backgroundContainer = "br_fw";
export var buttons = "br_cG";
export var container = "br_b";
export var middleWave = "br_cS";
export var section = "br_d";
export var text = "br_cm";
export var textContainer = "br_b1";
export var title = "br_h";